import { useMemo } from 'react';

import { useWorkspacePermissions } from '~/hooks/useWorkspacePermissions';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { canEditSavedSizes, canViewSavedSizes } from '~/utils/permissions/workspacePermissions';

export const usePrivateContextSavedSizesPermissions = () => {
  const { currentWorkspace } = useCurrentWorkspace();
  const { workspacePermissions } = useWorkspacePermissions({
    workspaceId: currentWorkspace?.id,
  });

  return useMemo(
    () => ({
      canEdit: canEditSavedSizes(workspacePermissions),
      canView: canViewSavedSizes(workspacePermissions),
    }),
    [workspacePermissions],
  );
};
